module.exports = __webpack_public_path__ + "static/media/1009813.a010d8d6.jpg";